import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    header: {
      title: (mode: 'create' | 'update' | 'duplicate') =>
        translate({
          id: `modal.unableToCreateRecurrentOrdersModal.default.header.title.${mode}`,
        }),
    },
    body: {
      description: (capacityPercentage: number, mode: 'create' | 'update' | 'duplicate') =>
        translate({
          id: `modal.unableToCreateRecurrentOrdersModal.default.body.description.${mode}`,
          values: { capacityPercentage },
        }),
    },

    footer: {
      manageStorage: translate({
        id: 'modal.unableToCreateRecurrentOrdersModal.default.footer.manageStorage',
      }),
      commit: (mode: 'create' | 'update' | 'duplicate') =>
        translate({
          id: `modal.unableToCreateRecurrentOrdersModal.default.footer.commit.${mode}`,
        }),
    },
  }))

  return api
}
